import React, { forwardRef } from "react";
import { Graphics } from "@pixi/react";
import { Settings } from "../../../settings";

const ReelSetMask = forwardRef(
  ({ symbolWidth, symbolHeight, dividerDimensions }, ref) => {
    const reelGridWidth =
      symbolWidth * Settings.REEL_COUNT +
      dividerDimensions.width * (Settings.REEL_COUNT - 1);

    const x = -reelGridWidth / 2;
    const y = -(symbolHeight * Settings.SYMBOLS_VISIBLE) / 2;
    const width = reelGridWidth;
    const height = symbolHeight * Settings.SYMBOLS_VISIBLE;

    return (
      <Graphics
        ref={ref}
        name="overflow_mask"
        draw={(g) => {
          g.clear();
          g.beginFill(0x000000, 1);
          g.drawRect(x, y, width, height);
          g.endFill();
        }}
      />
    );
  }
);

export default ReelSetMask;
